import { useNavigate, useParams } from "@tanstack/react-router";
import { Book, Plus } from "lucide-react";

import { Button } from "../../ui/button";
import {
  Empty,
  EmptyContent,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "../../ui/empty";

export const CategoriesEmptyState = () => {
  const params = useParams({ strict: false });
  const navigate = useNavigate();

  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <Book />
        </EmptyMedia>
        <EmptyTitle>Add categories to get started</EmptyTitle>
      </EmptyHeader>
      <EmptyContent>
        {/* V4.1: Route-based create for URL context tracking */}
        <Button
          onClick={() =>
            navigate({ to: `/menus/${params.menuId}/categories/new` })
          }
          type="button"
          variant="secondary"
        >
          <Plus className="text-foreground size-5" />
          Add Category
        </Button>
      </EmptyContent>
    </Empty>
  );
};
